<template>
  <div v-if="user.is_super_admin">
    <div class="row">
      <div class="col-lg-12">
        <div id="panel-user-live" class="panel">
          <div>
            <h5
              class="text-main pad-btm bord-btm"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              日报统计
              <el-date-picker
                size="small"
                v-model="dateRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                @change="getDailyData"
              ></el-date-picker>
            </h5>
            <div id="report-daily" style="height: 400px"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <div class="panel panel-warning panel-colorful media middle pad-all">
          <router-link to="/report/projects" class="text-white">
            <div class="media-left">
              <div class="pad-hor">
                <i class="ion-grid icon-3x"></i>
              </div>
            </div>
            <div class="media-body">
              <p class="text-2x mar-no text-semibold">
                {{ data.project_count }}
              </p>
              <p class="mar-no">项目</p>
            </div>
          </router-link>
        </div>
      </div>
      <div class="col-md-3">
        <div class="panel panel-mint panel-colorful media middle pad-all">
          <router-link to="/report/reports" class="text-white">
            <div class="media-left">
              <div class="pad-hor">
                <i class="ion-clipboard icon-3x"></i>
              </div>
            </div>
            <div class="media-body">
              <p class="text-2x mar-no text-semibold">
                {{ data.report_count }}
              </p>
              <p class="mar-no">日报</p>
            </div>
          </router-link>
        </div>
      </div>
      <div class="col-md-3">
        <div class="panel panel-info panel-colorful media middle pad-all">
          <router-link to="/report/drills" class="text-white">
            <div class="media-left">
              <div class="pad-hor">
                <i class="ion-navigate icon-3x"></i>
              </div>
            </div>
            <div class="media-body">
              <p class="text-2x mar-no text-semibold">{{ data.drill_count }}</p>
              <p class="mar-no">钻头</p>
            </div>
          </router-link>
        </div>
      </div>
      <div class="col-md-3">
        <div class="panel panel-danger panel-colorful media middle pad-all">
          <router-link to="/report/users" class="text-white">
            <div class="media-left">
              <div class="pad-hor">
                <i class="ion-person-stalker icon-3x"></i>
              </div>
            </div>
            <div class="media-body">
              <p class="text-2x mar-no text-semibold">{{ data.user_count }}</p>
              <p class="mar-no">用户</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel-body text-center m-t-20">欢迎回来。</div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/index'
import { reportStatistics } from '@/service/getData'
import * as echarts from 'echarts'

export default {
  data() {
    return {
      user: store.state.userInfo,
      dateRange: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      data: {},
    }
  },
  created() {
    if (this.user.is_super_admin) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      this.dateRange = [start, end]

      this.getDailyData()
      this.getData()
    }
  },
  methods: {
    async getDailyData() {
      let res = await reportStatistics({
        daily: true,

        start_time: this.$time(this.dateRange[0]).format('YYYY-MM-DD'),
        end_time: this.$time(this.dateRange[1]).format('YYYY-MM-DD'),
      })
      var xAxis = []
      var data = []
      res.data.map((item) => {
        xAxis.push(item.date)
        data.push(item.count)
      })

      var chartDom = document.getElementById('report-daily')
      var myChart = echarts.init(chartDom)
      var option = {
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: 10,
          right: 20,
          bottom: 10,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxis,
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: data,
            type: 'line',
            areaStyle: {},
          },
        ],
      }

      option && myChart.setOption(option)
    },

    async getData() {
      let res = await reportStatistics()
      this.data = res.data
    },
  },
}
</script>